import Importer from './Importer';
import Dot from '../track/Dot';
import Dots from '../track/Dots';

export default class ImporterGPX extends Importer {
  constructor(fileName, fileData) {
    super(fileName, fileData);

    this.SEGMENTS_TAG = 'trkpt';
  }

  import() {
    let dots = new Dots();

    let file = this.parseFile();

    let segments = file.getElementsByTagName(this.SEGMENTS_TAG);

    for (let i = 0; i < segments.length; i++) {
      // dots is an object so it's always passed by reference in JS
      this.addDot(dots, segments[i]);
    }

    return dots;
  }

  parseFile() {
    let parser = new DOMParser();
    return parser.parseFromString(this._fileData, 'application/xml');
  }

  // eslint-disable-next-line class-methods-use-this
  addDot(dots, dotRow) {
    let lat = parseFloat(dotRow.getAttribute('lat'));
    let lon = parseFloat(dotRow.getAttribute('lon'));
    if (lat && lon) {
      dots.add(new Dot(lat, lon));
    } else {
      // eslint-disable-next-line no-console
      console.warn('Not completed data in row');
    }
  }
}
